import Vue from 'vue'
import Meta from 'vue-meta'
import Router from 'vue-router'
import Portfolio from './views/Portfolio.vue'
import Kontakt from './views/Kontakt.vue'
import Tools from './views/Tools.vue'
import Vita from './views/Vita.vue'
import Impressum from './views/Impressum.vue'
import Datenschutz from './views/Datenschutz.vue'


Vue.use(Router)
Vue.use(Meta)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: 'editing'
    },

    {
      path: '/editing',
      name: 'editing',
      component: Portfolio,
      props: {
        subTitle: "Editing",
        category: "editing",
        openedComponent: "Editing",
      },
      meta: {
        title: 'Robin Jünkersfeld - Editor',
        metaTags: [
          {
            name: 'description',
            content: 'Robin Jünkersfeld arbeitet als Editor und Colorist. Diese Seite zeigt sein Editing Portfolio.'
          }
        ]
      }
    },

     {
       path: '/grading',
       name: 'grading',
       component: Portfolio,
       props: {
         subTitle: "Grading",
         category: "grading"
       },
       meta: {
         title: 'Robin Jünkersfeld - Colorist',
         metaTags: [
           {
             name: 'description',
             content: 'Robin Jünkersfeld arbeitet als Editor und Colorist. Diese Seite zeigt sein Grading Portfolio.'
           }
         ]
       }
     },

    {
      path: '/kontakt',
      name: 'kontakt',
      component: Kontakt,
      meta: {
        title: 'Robin Jünkersfeld - Kontakt',
        metaTags: [
          {
            name: 'description',
            content: 'Kontaktinformationen von Robin Jünkersfeld.'
          },
          {
            property: 'og:title',
            content: 'Kontaktdaten von Robin Jünkersfeld.'
          }
        ]
      }
    },

    {
      path: '/vita',
      name: 'vita',
      component: Vita,
      meta: {
        title: 'Robin Jünkersfeld - Vita',
        metaTags: [
          {
            name: 'description',
            content: 'Vita und About me von Robin Jünkersfeld.'
          },
          {
            property: 'og:title',
            content: 'Vita und About me von Robin Jünkersfeld.'
          }
        ]
      }
    },

    {
      path: '/impressum',
      name: 'impressum',
      component: Impressum,
      meta: {
        title: 'Robin Jünkersfeld - Impressum',
        metaTags: [
          {
            name: 'description',
            content: 'Impressum der Portfolioseite robinjuenkersfeld.de'
          }
        ]
      }
    },

    {
      path: '/datenschutz',
      name: 'datenschutz',
      component: Datenschutz,
      meta: {
        title: 'Robin Jünkersfeld - Datenschutz',
        metaTags: [
          {
            name: 'description',
            content: 'Datenschutzangaben der Portfolioseite robinjuenkersfeld.de'
          }
        ]
      }
    },

    {
      path: '/tools',
      name: 'tools',
      component: Tools,
      meta: {
        title: 'EDL Converter',
        metaTags: [
          {
            name: 'description',
            content: 'Avid Marker EDL Converter für Davinci Resolve.'
          },
        ]
      }
    }
  ]
})
